<template>
  <Modal
      v-model="_value"
      width="500"
      title="设置里程"
      @on-visible-change="visibleChange"
      ok-text="发送"
      @on-ok="onOk">
    <Form ref="loginForm" :model="device">
      <FormItem prop="mileage">
        <label style="display: inline-block; width: 200px;">行驶里程数（单位：0.1公里）</label>
        <InputNumber :min="0" :step="0.1" style="display: inline-block; width: 200px;" v-model="device.mileage"
                     placeholder="请输入行驶里程数">
        </InputNumber>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setupbsjmileagemodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        device: {
          id: null,
          mileage: 0
        }
      }
    },
    methods: {
      ...mapActions([
        'NetCommandServ_SetupMileage'
      ]),
      onOk() {
        this.device.mileage = this.device.mileage * 10
        store.dispatch('NetCommandServ_SetupMileage',
          {
            params: this.device
          }).then(() => {
          this.$Message.success('发送成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if (val) {
          this.device.id = this._initValue
          this.device.mileage = 0
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
